<template>
  <div>
    <div class="billInfo">
      <el-row>
        <el-col :span="8">合作商：{{ tableData[0].agentName }}</el-col>
        <el-col :span="8">业务线：{{ tableData[0].businessLineStr }}</el-col>
        <el-col :span="8">城市：{{ tableData[0].regionName }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8">结算账期：{{ tableData[0].periodMonth }}</el-col>
        <el-col :span="8"
          >对账单状态：<span class="ui-danger">{{ tableData[0].billProcessStatusStr }}</span></el-col
        >
        <el-col :span="8">合作校园：{{ tableData[0].street }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8"
          >账单总金额(元)：<span class="ui-danger">{{ tableData[0].billTotalMoney }}</span></el-col
        >
        <el-col :span="8">账单类别：{{ tableData[0].billTypeStr }}</el-col>
        <el-col :span="8">生成时间：{{ tableData[0].createTime }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8">实收总流水(元)：{{ tableData[0].actuallyMoney }}</el-col>
        <el-col :span="8">分成比例：{{ tableData[0].rate }}</el-col>
        <el-col :span="8">调整金额(元)：{{ tableData[0].changeMoney }}</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bill-detail',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
  },
}
</script>

<style scoped lang="scss">
  .invoice-info {
    .btn-wrap {
      margin-top: 10px;
      display: flex;
      flex-direction: row-reverse;
    }
  }
  .billTitle {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .billInfo {
    font-size: 14px;
    .el-row {
      margin-bottom: 10px;
    }
  }
  </style>
  <style lang="scss">
  button.el-button.el-button--default.el-button--primary.confirmButton_batch {
    background-color: rgb(255, 209, 0);
    &:hover {
      background-color: rgb(255, 209, 0);
    }
  }
  </style>